module.exports = __webpack_public_path__ + "resources/img/bg_cover_tcc.fb29ea69aa42d49c04a043c3452a4b60.jpg";